import * as Url from "../Url";
import * as Services from "../handler";

interface UploadImagePayload {
  img: string;
  target_img: string;
}
interface CheckCompletedImagePayload {
  image_id: string;
}
interface ExtractFacesMultiPayload {
  original_image?: string;
  faces?: string[];
}

export async function updateImage(payload: UploadImagePayload): Promise<any> {
  let res = await Services.POST(Url.APPLY_FACE_SWAP, payload);
  return res;
}

export async function checkCompletedImage(
  payload: CheckCompletedImagePayload
): Promise<any> {
  let res = await Services.POST(Url.COMPLETED_IMAGE, payload);
  return res;
}

export async function extractFacesMulti(
  payload: ExtractFacesMultiPayload
): Promise<any> {
  let res = await Services.POST(Url.EXTRACT_FACES_MULTI, payload);
  return res;
}
export async function updateMultiFaceImage(payload: ExtractFacesMultiPayload): Promise<any> {
  let res = await Services.POST(Url.APPLY__MULTI_FACE_SWAP, payload);
  return res;
}